import { useUserLanguage } from '@/customHooks';
import styled from 'styled-components';

type DebtBadgeProps = {
  hasDebt: boolean;
};

const BadgeContainer = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.25rem 0.6rem;
  border-radius: 12px;
  font-size: 0.7rem;
  font-weight: 600;
  color: #d97706;
  background-color: #fef3c7;
  border: 1px solid #fbbf24;
  margin-left: 0.5rem;
  white-space: nowrap;
  vertical-align: middle;
`;

const WarningIcon = styled.span`
  font-size: 0.8rem;
`;

const texts = {
  en: 'Has debt',
  es: 'Tiene deuda',
};

export const DebtBadge = ({ hasDebt }: DebtBadgeProps) => {
  const userLanguage = useUserLanguage();

  if (!hasDebt) return null;

  return (
    <BadgeContainer>
      <WarningIcon>⚠️</WarningIcon>
      {texts[userLanguage]}
    </BadgeContainer>
  );
};

